import type { ReactNode } from 'react';
import classnames from 'classnames';
import * as styles from './LinkList.module.scss';

export interface ILinkListProps {
    children: ReactNode;
    inline?: boolean;
    theme?: 'white' | 'secondary' | 'primary';
}

export function LinkList(props: ILinkListProps) {
    const className = classnames(props.theme ? styles[props.theme] : '', props.inline ? styles.inline : styles.list);

    return <ul className={className}>{props.children}</ul>;
}
